export const WhatIsAiAura = () => {
    return (
        <div className='relative pt-10'>
            <div className="max-w-7xl mx-auto text-white py-16 px-6 overflow-hidden py-[100px]">
                <div className="relative z-10 flex flex-col-reverse md:flex-row justify-between items-start gap-8 md:gap-36">
                    <div className="w-full md:w-1/2 pt-2">
                        <p className="font-lato font-light text-base md:text-[20px] md:leading-[34px]">
                            AIAURA Core is a next-generation internal mobility and referral platform, purpose-built for recruiters, talent teams, and agencies. It transforms internal networks, alumni, and previously engaged candidates into high-performing talent pipelines. With AI-powered matching, branded job boards, automated referral rewards, and recruiter-to-recruiter collaboration through CoreShare, AIAURA Core reduces hiring costs, speeds up time-to-hire, and improves quality of hire — all while integrating seamlessly with your existing systems.
                        </p>
                    </div>
                    <div className="mt-4 sm:mt-0 w-full md:w-1/2 h-[350px] rounded-xl overflow-hidden">
                        <img src="/ai_aura.png" alt="AI AURA" className="h-full w-full"/>
                    </div>
                </div>
            </div>
        </div>
    )
}
